import {
  calculateDeliveryTimeForProduct,
  getDisplayPriceLevel1,
  getDisplayPriceLevel3,
  getPriceLevel1,
  getPriceLevel3,
  getDisplayPriceBoxLevel3,
  getBoxPrice,
} from '@/helper/functions.js';
import BoxState from '@/model/Box';
import { replaceMixin } from '@/mixins/ReplaceMixin';
import { LoaderMixin } from '@/mixins/LoaderMixin';
import Vue from 'vue';
import axios from 'axios';

export const logicMixin = Vue.util.mergeOptions(replaceMixin, {
  mixins: [LoaderMixin],
  data: function() {
    return {
      touchPos: 0,
      lastWidth: 0,
      formatter: new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
      }),
    };
  },
  methods: {
    cLink(link) {
      return ((this.$store.getters.isB2b ? '/b2b' : '/b2c') + link).replace('/b2b/b2b', '/b2b').replace('/b2c/b2c', '/b2c');
    },
    getCalculatedTime(item) {
      let addForChristmas = 0;
      if ([62, 2569, 2571, 2548].includes(parseInt(this.$store.getters.getUserGroupId))) {
        addForChristmas = 0;
      }
      let time = 0;
      if (this.$store.getters.getCurrentLevel === 1) {
        item.products.forEach((product) => {
          if (product.replaced) {
            product = product.replaceData;
          }
          const tempTime = calculateDeliveryTimeForProduct(
            product,
            this.$store.getters.getSelectedQty,
            this.$store.getters.getDelTimeSettings
          );
          if (tempTime > time) {
            time = tempTime;
          }
        });
      } else if (this.$store.getters.getCurrentLevel === 3) {
        time = calculateDeliveryTimeForProduct(
          item,
          this.$store.getters.getSelectedQty,
          this.$store.getters.getSettings
        );
      }

      return time + addForChristmas;
    },
    getDeliveryReadyDate(days) {
      const date = new Date();
      if (date.getDay() === 0) {
        date.setDate(date.getDate() + 1);
      }
      if (date.getDay() === 6) {
        date.setDate(date.getDate() + 2);
      }
      while (
        this.$store.getters.getHolidays[date.getFullYear()] &&
        this.$store.getters.getHolidays[('0' + (date.getMonth() + 1)).slice(-2)] &&
        this.$store.getters.getHolidays[('0' + (date.getDate() + 1)).slice(-2)] === true
      ) {
        date.setDate(date.getDate() + 1);
      }

      while (days > 0) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() === 0) {
          date.setDate(date.getDate() + 1);
        }
        if (date.getDay() === 6) {
          date.setDate(date.getDate() + 2);
        }
        while (
          this.$store.getters.getHolidays[date.getFullYear()] &&
          this.$store.getters.getHolidays[date.getFullYear()][('0' + (date.getMonth() + 1)).slice(-2)] &&
          this.$store.getters.getHolidays[date.getFullYear()][('0' + (date.getMonth() + 1)).slice(-2)][('0' + (date.getDate())).slice(-2)] === true
        ) {
          date.setDate(date.getDate() + 1);
        }

        --days;
      }

      return date;
    },
    getDeliveryReadyDateString(days) {
      const date = this.getDeliveryReadyDate(days);

      return `${('0' + (date.getDate())).slice(-2)}.${('0' + (date.getMonth() + 1)).slice(-2)}.${date.getFullYear().toString().slice(-2)}`;
    },
    doPrepackaged(lvl1) {
      if (typeof (lvl1.prepackaged) !== 'undefined' && lvl1.prepackaged.exists) {
        lvl1.products.forEach(p => {
          if (p.stock_quantity <= lvl1.prepackaged.quantity) {
            p.stock_quantity = lvl1.prepackaged.quantity + 1;
            p.stock_status = 'instock';
          }
          p.prepackaged = {};
          p.prepackaged.exists = true;
          p.prepackaged.qty = lvl1.prepackaged.quantity;
        });
      }
    },
    doReplace() {
      if (this.$store.getters.getCurrentLevel === 1) {
        this.$store.getters.getListItemsLevel1Unfiltered.forEach(lvl1 => {
          this.doPrepackaged(lvl1);
          const tempReplaceQty = {};
          lvl1.products.forEach(p => {
            const replaceProducts = this.getReplaceProductsFor(p.product);
            let replaced = false;
            let replaceData = {};
            let replacerQty = p.stock_quantity;
            // Ersetzen solange Produkte in Stock...
            replaceProducts.forEach(r => {
              if (typeof r !== 'undefined') {
                if (!(r.id in tempReplaceQty)) {
                  tempReplaceQty[r.id] = 0;
                }
                if (p.stock_quantity < this.boxQty * p.quantity && r.stock_quantity - tempReplaceQty[r.id] >= this.boxQty * p.quantity && replaced === false) {
                  replaced = true;
                  replaceData = r;
                  tempReplaceQty[r.id] += this.boxQty * p.quantity;
                }
                if (r.stock_quantity > replacerQty) {
                  replacerQty = r.stock_quantity;
                }
              }
            });

            // Ersetzen nach geringste Lieferzeit
            if (replaced === false && p.stock_quantity < this.boxQty * p.quantity) {
              let time = 99999999;
              if (p.custom_delivery_qty.allow_backorders === 'ja') {
                if (p.stock_quantity + p.custom_delivery_qty.threshold_1 - 1 < this.boxQty * p.quantity) {
                  time = p.custom_delivery_qty.threshold_1_time;
                } else {
                  const numbers = p.delivery_time.split('-');
                  let minTimeProduct = 0;
                  let maxTimeProduct = 0;
                  if (
                    numbers.length === 1 &&
                              parseInt(numbers[0]) > minTimeProduct &&
                              parseInt(numbers[0]) > maxTimeProduct
                  ) {
                    minTimeProduct = parseInt(numbers[0]);
                    maxTimeProduct = parseInt(numbers[0]);
                  } else if (
                    numbers.length === 3 &&
                              parseInt(numbers[1]) > minTimeProduct &&
                              parseInt(numbers[1]) > maxTimeProduct
                  ) {
                    minTimeProduct = parseInt(numbers[1]);
                    maxTimeProduct = parseInt(numbers[1]);
                  } else if (
                    numbers.length === 4 &&
                              parseInt(numbers[1]) > minTimeProduct &&
                              parseInt(numbers[2]) > maxTimeProduct
                  ) {
                    minTimeProduct = parseInt(numbers[1]);
                    maxTimeProduct = parseInt(numbers[2]);
                  }
                  time = (minTimeProduct + maxTimeProduct) / 2;
                }
              }

              replaceProducts.forEach(r => {
                if (typeof r === 'undefined') {
                  return;
                }
                let timeReplace = 99999999;
                if (r.custom_delivery_qty.allow_backorders === 'ja') {
                  if (r.stock_quantity + r.custom_delivery_qty.threshold_1 - 1 < this.boxQty * p.quantity) {
                    timeReplace = r.custom_delivery_qty.threshold_1_time;
                  } else {
                    const numbers = r.delivery_time.split('-');
                    let minTimeProduct = 0;
                    let maxTimeProduct = 0;
                    if (
                      numbers.length === 1 &&
                                parseInt(numbers[0]) > minTimeProduct &&
                                parseInt(numbers[0]) > maxTimeProduct
                    ) {
                      minTimeProduct = parseInt(numbers[0]);
                      maxTimeProduct = parseInt(numbers[0]);
                    } else if (
                      numbers.length === 3 &&
                                parseInt(numbers[1]) > minTimeProduct &&
                                parseInt(numbers[1]) > maxTimeProduct
                    ) {
                      minTimeProduct = parseInt(numbers[1]);
                      maxTimeProduct = parseInt(numbers[1]);
                    } else if (
                      numbers.length === 4 &&
                                parseInt(numbers[1]) > minTimeProduct &&
                                parseInt(numbers[2]) > maxTimeProduct
                    ) {
                      minTimeProduct = parseInt(numbers[1]);
                      maxTimeProduct = parseInt(numbers[2]);
                    }
                    timeReplace = (minTimeProduct + maxTimeProduct) / 2;
                  }
                }

                if (timeReplace < time) {
                  time = timeReplace;
                  replaced = true;
                  replaceData = r;
                }
              });
            }

            p.replaced = replaced;
            p.replaceData = replaceData;
            p.replacerQty = replacerQty;
          });
        });
      }
    },
    getReplaceRaw() {
      if (this.$store.getters.getCurrentLevel === 1) {
        const tempReplaceQty = {};
        const replaceData = {};
        this.$store.getters.getSelectedItem.includedProducts().forEach(p => {
          const replaceProducts = this.getReplaceProductsFor(p.product);
          let replaced = false;
          replaceProducts.forEach(r => {
            if (!(r.id in tempReplaceQty)) {
              tempReplaceQty[r.id] = 0;
            }
            if (p.stock_quantity < this.boxQty * p.quantity && r.stock_quantity - tempReplaceQty[r.id] >= this.boxQty * p.quantity && replaced === false) {
              replaced = true;
              replaceData[p.product] = r.id;
              tempReplaceQty[r.id] += this.boxQty * p.quantity;
            }
          });

          if (replaced === false && p.stock_quantity < this.boxQty * p.quantity) {
            let time = 99999999;
            if (p.custom_delivery_qty.allow_backorders === 'ja') {
              if (p.stock_quantity + p.custom_delivery_qty.threshold_1 - 1 < this.boxQty * p.quantity) {
                time = p.custom_delivery_qty.threshold_1_time;
              } else {
                const numbers = p.delivery_time.split('-');
                let minTimeProduct = 0;
                let maxTimeProduct = 0;
                if (
                  numbers.length === 1 &&
                            parseInt(numbers[0]) > minTimeProduct &&
                            parseInt(numbers[0]) > maxTimeProduct
                ) {
                  minTimeProduct = parseInt(numbers[0]);
                  maxTimeProduct = parseInt(numbers[0]);
                } else if (
                  numbers.length === 3 &&
                            parseInt(numbers[1]) > minTimeProduct &&
                            parseInt(numbers[1]) > maxTimeProduct
                ) {
                  minTimeProduct = parseInt(numbers[1]);
                  maxTimeProduct = parseInt(numbers[1]);
                } else if (
                  numbers.length === 4 &&
                            parseInt(numbers[1]) > minTimeProduct &&
                            parseInt(numbers[2]) > maxTimeProduct
                ) {
                  minTimeProduct = parseInt(numbers[1]);
                  maxTimeProduct = parseInt(numbers[2]);
                }
                time = (minTimeProduct + maxTimeProduct) / 2;
              }
            }

            replaceProducts.forEach(r => {
              let timeReplace = 99999999;
              if (r.custom_delivery_qty.allow_backorders === 'ja') {
                if (r.stock_quantity + r.custom_delivery_qty.threshold_1 - 1 < this.boxQty * p.quantity) {
                  timeReplace = r.custom_delivery_qty.threshold_1_time;
                } else {
                  const numbers = r.delivery_time.split('-');
                  let minTimeProduct = 0;
                  let maxTimeProduct = 0;
                  if (
                    numbers.length === 1 &&
                              parseInt(numbers[0]) > minTimeProduct &&
                              parseInt(numbers[0]) > maxTimeProduct
                  ) {
                    minTimeProduct = parseInt(numbers[0]);
                    maxTimeProduct = parseInt(numbers[0]);
                  } else if (
                    numbers.length === 3 &&
                              parseInt(numbers[1]) > minTimeProduct &&
                              parseInt(numbers[1]) > maxTimeProduct
                  ) {
                    minTimeProduct = parseInt(numbers[1]);
                    maxTimeProduct = parseInt(numbers[1]);
                  } else if (
                    numbers.length === 4 &&
                              parseInt(numbers[1]) > minTimeProduct &&
                              parseInt(numbers[2]) > maxTimeProduct
                  ) {
                    minTimeProduct = parseInt(numbers[1]);
                    maxTimeProduct = parseInt(numbers[2]);
                  }
                  timeReplace = (minTimeProduct + maxTimeProduct) / 2;
                }
              }

              if (timeReplace < time) {
                time = timeReplace;
                replaced = true;
                replaceData[p.product] = r.id;
              }
            });
          }
        });

        return replaceData;
      }

      return {};
    },
    getReplaceRawSku() {
      const ret = {};
      const data = this.getReplaceRaw();
      Object.keys(data).forEach((key) => {
        ret[this.$store.getters.getListItemsLevel3All[this.$store.getters.getIdToIdx[key]].sku] = this.$store.getters.getListItemsLevel3All[this.$store.getters.getIdToIdx[data[key]]].sku;
      });

      return ret;
    },
    splitTaxSum(products, priceToSplit) {
      let sum = 0.0;
      let sumTax7 = 0.0;
      let sumTax19 = 0.0;
      products.forEach(p => {
        sum += p.price;
        if (p.taxRate === 7) {
          sumTax7 += p.price;
        } else {
          sumTax19 += p.price;
        }
      });
      if (products.length === 0) {
        // lvl3 no products, fake 7% tax
        sumTax7 = 1;
        sum = 1;
      }

      const percentage7 = ((sumTax7 * 100) / sum) / 100;
      const percentage19 = ((sumTax19 * 100) / sum) / 100;
      const tax7 = parseFloat(((priceToSplit * percentage7) / 1.07).toFixed(8));
      const tax19 = parseFloat(((priceToSplit * percentage19) / 1.19).toFixed(8));

      return {
        tax7,
        tax19
      };
    },
    splittedTaxSingleRawSum(price) {
      return this.splitTaxSum(this.$store.getters.getSelectedItem.includedProducts().map(p => {
        if (this.$store.getters.getCurrentLevel === 3) {
          return {
            price: this.getPriceRawForGroup(p, this.$store.getters.getUserGroupId, true),
            taxRate: p.tax,
          };
        }
        if (p.replaced) {
          return {
            price: this.getPriceRawForGroup({ products: [p.replaceData] }, this.$store.getters.getUserGroupId, true),
            taxRate: p.replaceData.tax,
          };
        }
        return {
          price: this.getPriceRawForGroup({ products: [p] }, this.$store.getters.getUserGroupId, true),
          taxRate: p.tax,
        };
      }), price);
    },
    splitTax(products, priceToSplit) {
      let sum = 0.0;
      let sumTax7 = 0.0;
      let sumTax19 = 0.0;
      products.forEach(p => {
        sum += p.price;
        if (p.taxRate === 7) {
          sumTax7 += p.price;
        } else {
          sumTax19 += p.price;
        }
      });
      if (products.length === 0) {
        // lvl3 no products, fake 7% tax
        sumTax7 = 1;
        sum = 1;
      }

      const percentage7 = ((sumTax7 * 100) / sum) / 100;
      const percentage19 = ((sumTax19 * 100) / sum) / 100;
      const tax7 = parseFloat(((priceToSplit * percentage7) * 1.07).toFixed(8));
      const tax19 = parseFloat(((priceToSplit * percentage19) * 1.19).toFixed(8));
      return {
        tax7: parseFloat(((priceToSplit * percentage7) + tax7).toFixed(8)),
        tax19: parseFloat(((priceToSplit * percentage19) + tax19).toFixed(8)),
        gross: parseFloat((tax19 + tax7).toFixed(2)),
        net: parseFloat((tax19 / 1.19 + tax7 / 1.07).toFixed(2))
      };
    },
    splittedTaxSingleRaw(price) {
      return this.splitTax(this.$store.getters.getSelectedItem.includedProducts().map(p => {
        if (this.$store.getters.getCurrentLevel === 3) {
          return {
            price: this.getPriceRawForGroup(p, this.$store.getters.getUserGroupId, true),
            taxRate: p.tax,
          };
        }
        if (p.replaced) {
          return {
            price: this.getPriceRawForGroup({ products: [p.replaceData] }, this.$store.getters.getUserGroupId, true),
            taxRate: p.replaceData.tax,
          };
        }
        return {
          price: this.getPriceRawForGroup({ products: [p] }, this.$store.getters.getUserGroupId, true),
          taxRate: p.tax,
        };
      }), price).gross;
    },
    splittedTaxSingleRawNet(price) {
      return this.splitTax(this.$store.getters.getSelectedItem.includedProducts().map(p => {
        if (this.$store.getters.getCurrentLevel === 3) {
          return {
            price: this.getPriceRawForGroup(p, this.$store.getters.getUserGroupId, true),
            taxRate: p.tax,
          };
        }
        if (p.replaced) {
          return {
            price: this.getPriceRawForGroup({ products: [p.replaceData] }, this.$store.getters.getUserGroupId, true),
            taxRate: p.replaceData.tax,
          };
        }
        return {
          price: this.getPriceRawForGroup({ products: [p] }, this.$store.getters.getUserGroupId, true),
          taxRate: p.tax,
        };
      }), price).net;
    },
    splittedTaxSingle(price) {
      return this.humanPrice(this.splittedTaxSingleRaw(price));
    },
    splittedTaxSingleNet(price) {
      return this.humanPrice(this.splittedTaxSingleRawNet(price));
    },
    getTaxIncExc: function() {
      if (this.$store.getters.isB2b) {
        return '';
      }
      return 'inkl. MwSt.';
    },
    getPriceLevel3: function(item) {
      return this.getPriceLevel3ForGroup(
        item,
        this.$store.getters.getUserGroupId,
        this.$store.getters.isB2b
      );
    },
    getPriceLevel3ForGroup: function(item, group, isB2b) {
      return getDisplayPriceLevel3(item, group, isB2b);
    },
    getPriceBox: function() {
      return this.getPriceBoxForGroup(
        this.$store.getters.getUserGroupId,
        this.$store.getters.isB2b
      );
    },
    getPriceBoxForGroup: function(group, isB2b) {
      let item = this.$store.getters.getLevel3Box;
      if (
        this.$store.getters.getSelectedItem.data === null &&
        this.$store.getters.getCurrentLevel === 3
      ) {
        item = this.$store.getters.getBoxItemsLevel3[0];
      }
      return getDisplayPriceBoxLevel3(item, group, isB2b);
    },
    getPriceBoxRaw: function() {
      return this.getPriceBoxRawForGroup(
        this.$store.getters.getUserGroupId,
        true
      );
    },
    getPriceBoxRawForGroup: function(group, isB2b) {
      isB2b = true;
      let item = this.$store.getters.getLevel3Box;
      if (
        this.$store.getters.getSelectedItem.data === null &&
        this.$store.getters.getCurrentLevel === 3
      ) {
        item = this.$store.getters.getBoxItemsLevel3[0];
      }
      return getBoxPrice(item, group, isB2b);
    },
    removeProduct: function(index) {
      this.$store.commit('removeLevel3', index);
      this.$root.$emit('removedLevel3Item');
      this.updateAfterLevel3();
    },
    updateAfterLevel3: function() {
      if (this.$store.getters.getCurrentLevel === 3) {
        const checker = new BoxState();
        if (this.$store.getters.getSelectedItem.data !== null) {
          checker.products = this.$store.getters.getSelectedItem.data.products;
        }
        const helper = {};
        let available = 0;
        let notAvailable = 0;
        this.$store.getters.getListItemsLevel3All.forEach(product => {
          const result = checker.checkInsert(
            this.$store.getters.getBoxItemsLevel3[0],
            product
          );
          if (result.remainingProducts.length === 0) {
            helper[product.id] = {
              placeable: true
            };
            available += 1;
          } else {
            helper[product.id] = {
              placeable: false
            };
            notAvailable += 1;
          }
        });
        this.$store.commit(
          'setLevel3Available',
          (notAvailable * 100) / (notAvailable + available) > 80
        );
        this.$store.commit('setLevel3NotAvailable', available === 0);
        this.$store.commit('setLevel3Helper', helper);
        this.$store.commit(
          'setCurrentBox',
          checker.currentStatus(this.$store.getters.getBoxItemsLevel3[0])
        );
      }
    },
    getPrice: function(item) {
      return this.getPriceForGroup(
        item,
        this.$store.getters.getUserGroupId,
        this.$store.getters.isB2b
      );
    },
    getPriceForGroup: function(item, group, isB2b) {
      if (
        this.$store.getters.getCurrentLevel === 1 ||
        item.type === 'level_3'
      ) {
        return getDisplayPriceLevel1(item, group, true, isB2b);
      }

      return getDisplayPriceLevel3(item, group, isB2b);
    },
    getPriceRaw: function(item) {
      return this.getPriceRawForGroup(
        item,
        this.$store.getters.getUserGroupId,
        this.$store.getters.isB2b
      );
    },
    getPriceRawForGroup: function(item, group, isB2b) {
      if (
        (this.$store.getters.getCurrentLevel === 1 ||
        item.type === 'level_3') &&
        item.products
      ) {
        return getPriceLevel1(item, group, false, isB2b);
      }

      return getPriceLevel3(item, group, isB2b);
    },
    addLevel3: function(item) {
      this.$store.commit('addLevel3', { ...item });
      this.$store.commit(
        'setLevel3Box',
        this.$store.getters.getBoxItemsLevel3[0]
      );
      this.updateAfterLevel3();
      this.$store.commit('setModalOpen', false);
      this.$root.$emit('boxPreviewInside');
      this.$root.$emit('addedLevel3Item');
      if (document.getElementsByClassName('--hide-on-scroll').length > 0) {
        document.getElementsByClassName('--hide-on-scroll')[0].scrollTop = 0;
      }
      if (
        document.getElementsByClassName('level-3-preview-container').length > 0
      ) {
        document.getElementsByClassName(
          'level-3-preview-container'
        )[0].scrollTop = 0;
      }
    },
    onResize: function() {
      if (Math.abs(window.innerWidth - this.lastWidth) > 50) {
        this.lastWidth = window.innerWidth;
        if (window.innerWidth <= this.$store.getters.getBreakpointMobile) {
          this.$store.commit('setIsMobile', true);
        } else {
          this.$store.commit('setIsMobile', false);
        }
      }
    },
    touchStartHandler: function(e) {
      if (document.getElementsByClassName('--hide-on-scroll').length > 0) {
        document
          .getElementsByClassName('--hide-on-scroll')[0]
          .addEventListener('touchstart', this.stopBubbling);
        document
          .getElementsByClassName('--hide-on-scroll')[0]
          .addEventListener('touchmove', this.stopBubbling);
      }
      if (
        document.getElementsByClassName('level-3-preview-container').length > 0
      ) {
        document
          .getElementsByClassName('level-3-preview-container')[0]
          .addEventListener('touchstart', this.stopBubbling);
        document
          .getElementsByClassName('level-3-preview-container')[0]
          .addEventListener('touchmove', this.stopBubbling);
      }
      this.touchPos = e.touches[0].clientY;
    },
    touchMoveHandler: function(e) {
      if (this.$store.getters.isMobile) {
        const te = e.changedTouches[0].clientY;
        const el = document.getElementsByClassName('--hide-on-scroll');
        if (this.touchPos > te + 50) {
          if (el.length > 0) {
            el[0].style.marginTop = '-150px';
          }
          this.$root.$emit('showPreviewAgain');
        } else if (this.touchPos < te - 50) {
          if (el.length > 0 && document.documentElement.scrollTop < 100) {
            el[0].style.marginTop = '0px';
          }
          this.$root.$emit('showPreviewAgain');
        }
      }
    },
    stopBubbling: function(e) {
      e.stopPropagation();
    },
    setLastQty() {
      if (localStorage.getItem('lastSelectedQty') !== null) {
        this.$store.commit(
          'setSelectedQty',
          { qty: localStorage.getItem('lastSelectedQty'), store: this.$store }
        );

        if (this.$store.getters.isB2b) {
          this.$store.commit(
            'setLevel1FilterB2bQty',
            localStorage.getItem('lastSelectedQty')
          );
          this.$store.commit(
            'setLevel3FilterB2bQty',
            localStorage.getItem('lastSelectedQty')
          );
        }
      }
    },
    productDetailString: function(product) {
      if (product.taste !== '' && product.taste !== '0') {
        return `${product.base_product} · ${product.taste} · von ${product.manufacturer}`;
      }

      return `${product.base_product} · von ${product.manufacturer}`;
    },
    productDetailStringBold1: function(product) {
      if (product.taste !== '' && product.taste !== '0') {
        return `<strong>${product.base_product}</strong> · ${product.taste} · von ${product.manufacturer}`;
      }

      return `<strong>${product.base_product}</strong> · von ${product.manufacturer}`;
    },
    productDetailStringVar1Bold1: function(product) {
      if (product.taste !== '' && product.taste !== '0') {
        return `<b>${product.base_product}</b> · ${product.taste}`;
      }

      return `<b>${product.base_product}</b>`;
    },
    level1MaxQty: function(item) {
      let qty = 999999;
      item.products.forEach((product) => {
        if (product.stock_quantity < qty) {
          qty = product.stock_quantity;
        }
      });

      return qty;
    },
    level1CompleteStock: function(item) {
      let completeStock = true;
      item.products.forEach(product => {
        if (product.stock_status !== 'instock') {
          completeStock = false;
        }
      });

      return completeStock;
    },
    humanPrice: function (price) {
      return this.formatter.format(price);
    },
    extendLvl1Req: function(data) {
      Object.keys(data.prods).forEach(key => {
        data.prods[key].photos.forEach(i => {
          if (typeof i.original === 'string' || i.original instanceof String) {
            i.original = i.original.replace('.png', '.com.png').replace(process.env.VUE_APP_BASE_URL, process.env.VUE_APP_CDN_URL);
          }
        });
      });
      data.lvl1.forEach(lvl1 => {
        lvl1.products = lvl1.products.map(det => {
          const attributes = [];
          for (const [key, value] of Object.entries(data.prods[det.id].atts)) {
            attributes.push({ name: key, value });
          }
          const ret = {
            product: data.prods[det.id].product,
            release_date: data.prods[det.id].rel_date,
            type: data.prods[det.id].type,
            price: Object.keys(det.price).length > 0 ? det.price : data.prods[det.id].price,
            originalPrice: data.prods[det.id].oPrice,
            originalPriceNet: data.prods[det.id].oPriceNet,
            tax: data.prods[det.id].tax,
            name: data.prods[det.id].name,
            quantity: det.qty,
            delivery_time: data.prods[det.id].del_time ? data.prods[det.id].del_time : 'ca. 1-3 Werktage',
            stock_quantity: data.prods[det.id].stock_qty,
            stock_status: data.prods[det.id].stock_stat,
            food_info: data.prods[det.id].f_info,
            attributes,
            brands: data.prods[det.id].brands,
            description: data.prods[det.id].desc,
            short_description: data.prods[det.id].s_desc,
            age_restriction: data.prods[det.id].age_rest,
            base_product: data.prods[det.id].base_prod,
            taste: data.prods[det.id].taste,
            manufacturer: data.prods[det.id].manufact,
            custom_delivery_qty: {
              allow_backorders: data.prods[det.id].c_del_qty.backorders,
              threshold_1: data.prods[det.id].c_del_qty.trigger,
              threshold_1_time: data.prods[det.id].c_del_qty.trigger_time,
            },
            category: data.prods[det.id].cat.split(';'),
            event: data.prods[det.id].event,
            origin_country: data.prods[det.id].o_ctry,
            origin_iso: data.prods[det.id].o_iso,
            fut_days: data.prods[det.id].fut_days,
            sku: data.prods[det.id].sku,
            replaced: false,
            replaceData: {},
            photos: {
              b2c: data.prods[det.id].photos,
              b2b: data.prods[det.id].photos,
            },
            prepackaged: data.prods[det.id].prepackaged
          };
          // if (Object.keys(ret.price).length === 0) {
          //   ret.price.default = ret.originalPrice;
          //   ret.price.default_net = ret.originalPriceNet;
          // }
          if (!('default' in ret.price)) {
            ret.price.default = ret.originalPrice;
          }
          if (!('default_net' in ret.price)) {
            ret.price.default_net = ret.originalPriceNet;
          }
          return ret;
        });
      });

      data.lvl1 = data.lvl1.map(lvl1 => {
        const modified = { b2c: [], b2b: [] };
        Object.keys(lvl1.gll).forEach(key => {
          if (lvl1.gll[key].photos.b2c.original) {
            lvl1.gll[key].photos.b2c.original = lvl1.gll[key].photos.b2c.original.replace('.png', '.com.png').replace(process.env.VUE_APP_BASE_URL, process.env.VUE_APP_CDN_URL);
          }

          if (lvl1.gll[key].photos.b2b && lvl1.gll[key].photos.b2b.length > 0) {
            lvl1.gll[key].photos.b2b.original = lvl1.gll[key].photos.b2b.original.replace('.png', '.com.png').replace(process.env.VUE_APP_BASE_URL, process.env.VUE_APP_CDN_URL);
          }

          // Create "photos" object
          modified.b2c.push({
            original: lvl1.gll[key].photos.b2c.original ? lvl1.gll[key].photos.b2c.original : '',
          });

          if (lvl1.gll[key].photos.b2b && lvl1.gll[key].photos.b2b.length > 0) {
            modified.b2b.push({
              original: lvl1.gll[key].photos.b2b.original ? lvl1.gll[key].photos.b2b.original : '',
            });
          } else {
            modified.b2b.push({
              original: lvl1.gll[key].photos.b2c.original ? lvl1.gll[key].photos.b2c.original : '',
            });
          }
        });

        return {
          id: lvl1.id,
          sku: lvl1.sku,
          type: lvl1.type,
          name: lvl1.name,
          description: lvl1.desc,
          level1_tags: lvl1.level1_tags === '' ? [] : lvl1.level1_tags,
          tags: lvl1.tags,
          products: lvl1.products,
          delivery_time: lvl1.del_time,
          global_delivery_time: lvl1.g_del_time,
          occasions: lvl1.occasions,
          seo: lvl1.seo,
          delivery_times_qty: lvl1.delivery_times_qty,
          delivery_times_qty_max: lvl1.delivery_times_qty_max,
          gallery: lvl1.gll,
          photos: modified,
          theme: lvl1.thm === null ? 'default' : lvl1.thm,
          extra: lvl1.extra,
          prepackaged: lvl1.prepackaged,
          available_without_group: lvl1.a_wo_g
        };
      });

      return data.lvl1;
    },
    extendLvl3Req: function(data) {
      return data.map(lvl3 => {
        const attributes = [];
        for (const [key, value] of Object.entries(lvl3.atts)) {
          attributes.push({ name: key, value });
        }
        return {
          id: lvl3.id,
          sku: lvl3.sku,
          release_date: lvl3.rel_date,
          type: lvl3.type,
          price: lvl3.price,
          originalPrice: lvl3.oPrice,
          originalPriceNet: lvl3.oPriceNet,
          tax: lvl3.tax,
          name: lvl3.name,
          delivery_time: lvl3.del_time,
          stock_quantity: lvl3.stock_qty,
          stock_status: lvl3.stock_stat,
          food_info: lvl3.f_info,
          attributes,
          rotatable: lvl3.rotatable,
          dim_x: lvl3.dim_x,
          dim_y: lvl3.dim_y,
          brands: lvl3.brands,
          description: lvl3.desc,
          short_description: lvl3.s_desc,
          age_restriction: lvl3.age_rest,
          base_product: lvl3.base_prod,
          taste: lvl3.taste,
          manufacturer: lvl3.manufact,
          custom_delivery_qty: {
            allow_backorders: lvl3.c_del_qty.backorders,
            threshold_1: lvl3.c_del_qty.trigger,
            threshold_1_time: lvl3.c_del_qty.trigger_time,
          },
          category: lvl3.cat.split(';'),
          event: lvl3.event,
          origin_country: lvl3.o_ctry,
          origin_iso: lvl3.o_iso,
          fut_days: lvl3.fut_days,
          replaceProducts: lvl3.rep === '' ? {} : JSON.parse(lvl3.rep),
          photos: {
            b2c: lvl3.photos.map(e => {
              return {
                original: e.original ? e.original.replace(process.env.VUE_APP_BASE_URL, process.env.VUE_APP_CDN_URL) : '',
              };
            }),
            b2b: lvl3.photos.map(e => {
              return {
                original: e.original ? e.original.replace(process.env.VUE_APP_BASE_URL, process.env.VUE_APP_CDN_URL) : '',
              };
            }),
          }
        };
      });
    },

    selectedIsInList () {
      let isIn = false;

      if (this.$store.getters.getSelectedItem.data !== null) {
        this.$store.getters.getListItemsLevel1Filtered.forEach(element => {
          if (element.id === this.$store.getters.getSelectedItem.data.id) {
            isIn = true;
          }
        });

        if (this.$store.getters.getSelectedItem.data.available_without_group) {
          isIn = true;
        }
      }

      return isIn;
    },

    allInList() {
      let allInList = true;
      if (this.$store.getters.getSelectedItem.data !== null) {
        this.$store.getters.getSelectedItem.data.products.forEach(element => {
          let eInList = false;
          this.$store.getters.getListItemsLevel3.forEach(element2 => {
            if (element.id === element2.id) {
              eInList = true;
            }
          });

          if (!eInList) {
            allInList = false;
          }
        });
      }

      return allInList;
    },

    getBoxPriceLvl1(item, group, net) {
      let price = 0;
      const products = [];
      item.products.forEach(p => {
        if (p.type === 'box') {
          if (group in p.price) {
            price = parseFloat(p.price[group]);
            /* if (this.$store.getters.isB2b && group.toString() !== '22832') {
              price = price * (1 + (p.tax / 100));
            } */
          } else if ('default' in p.price) {
            price = p.price.default_net;
          }
        } else {
          products.push({
            price: this.getPriceRawForGroup(p, group, true) * p.quantity,
            taxRate: p.tax
          });
        }
      });

      if (!net) {
        price = this.splitTax(products, price).gross;
      }
      return price;
    },
    productIsUnavailable(product) {
      if (product === undefined) {
        return false;
      }
      let unavailable = false;
      if (this.$store.getters.getCurrentLevel === 1) {
        if (product.replaced) {
          if (
            (product.replaceData.stock_status !== 'instock' &&
            this.$store.getters.getSelectedQty < 20) ||
              (product.replaceData.stock_quantity < this.$store.getters.getSelectedQty * product.quantity &&
                (this.$store.getters.getSelectedQty < 20 ||
                  product.replaceData.custom_delivery_qty.allow_backorders !== 'ja'))
          ) {
            unavailable = true;
          }
        } else {
          if (
            (product.stock_status !== 'instock' &&
            this.$store.getters.getSelectedQty < 20) ||
              (product.stock_quantity < this.$store.getters.getSelectedQty * product.quantity &&
                (this.$store.getters.getSelectedQty < 20 ||
                  product.custom_delivery_qty.allow_backorders !== 'ja'))
          ) {
            unavailable = true;
          }
        }
      } else if (this.$store.getters.getCurrentLevel === 3) {
        if (this.boxQty > this.$store.getters.getSelectedItem.maxBoxQtyLevel3Product(this.$store, product)) {
          unavailable = true;
          if (product.custom_delivery_qty.allow_backorders === 'ja' && this.boxQty >= 20) {
            unavailable = false;
          }
        }
      }

      return unavailable;
    },

    // Called upon switching between b2c and b2b
    switchCustomerType (type) {
      if (type && ((type === 'b2b' && this.$store.getters.isB2b) || (type === 'b2c' && !this.$store.getters.isB2b))) {
        return;
      } else {
        type = this.$store.getters.isB2b ? 'b2c' : 'b2b';
      }

      if (parseInt(this.$store.getters.getUserGroupId) !== 62 && parseInt(this.$store.getters.getUserGroupId) !== 2571) {
        // Other group like fleurop, tecis, arag
        return;
      }

      this.$store.commit('setGlobalLoading', true);

      if (type === 'b2c') {
        this.$router.push(this.$route.path.replace('b2b', 'b2c'));
        // history.pushState({}, '', '/praesente' + this.$route.path.replace('b2b', 'b2c'));
        this.$store.commit('setUserGroupId', '62');
        axios
          .get(
            process.env.VUE_APP_BASE_URL +
                '/save_user_id.php?hard=1&given_group_id=62'
          )
          .then(() => {});
      } else if (type === 'b2b') {
        this.$router.push(this.$route.path.replace('b2c', 'b2b'));
        // history.pushState({}, '', '/praesente' + this.$route.path.replace('b2c', 'b2b'));
        this.$store.commit('setUserGroupId', '2571');
        axios
          .get(
            process.env.VUE_APP_BASE_URL +
                '/save_user_id.php?hard=1&given_group_id=2571'
          )
          .then(() => {});
      }

      this.$root.$emit('switchedUserGroup');

      this.loadLevel1();
      this.$store.commit('setGlobalLoading', false);
    }
  },
  computed: {
    noCalcTxt() {
      return this.$store.getters.getMsgSettings[this.$store.getters.getUserGroupId] && this.$store.getters.getMsgSettings[this.$store.getters.getUserGroupId].noCalcLength;
    },
    composerPrices() {
      if (this.$store.getters.getSelectedItem.data === null) {
        return [];
      }

      const prices = [];

      // Box Item
      let price = 0;
      let netPrice = 0;

      if (this.$store.getters.getCurrentLevel === 1) {
        price = this.getPriceRawForGroup(this.$store.getters.getSelectedItem.data, this.$store.getters.getUserGroupId, false);
        netPrice = this.getPriceRawForGroup(this.$store.getters.getSelectedItem.data, this.$store.getters.getUserGroupId, true);
        price += this.getBoxPriceLvl1(this.$store.getters.getSelectedItem.data, this.$store.getters.getUserGroupId, false);
        netPrice += this.getBoxPriceLvl1(this.$store.getters.getSelectedItem.data, this.$store.getters.getUserGroupId, true);
        prices.push({
          key: 'item',
          qty: this.boxQty,
          singlePriceRaw: price,
          singlePrice: this.humanPrice(price),
          multPriceRaw: price * this.boxQty,
          multPrice: this.humanPrice(price * this.boxQty),
          netSinglePriceRaw: netPrice,
          netSinglePrice: this.humanPrice(netPrice),
          netMultPriceRaw: netPrice * this.boxQty,
          netMultPrice: this.humanPrice(netPrice * this.boxQty),
        });
      } else if (this.$store.getters.getCurrentLevel === 3) {
        price = this.getPriceRawForGroup(this.$store.getters.getSelectedItem.data, this.$store.getters.getUserGroupId, false);
        netPrice = this.getPriceRawForGroup(this.$store.getters.getSelectedItem.data, this.$store.getters.getUserGroupId, true);
        prices.push({
          key: 'item',
          qty: this.boxQty,
          singlePriceRaw: price,
          singlePrice: this.humanPrice(price),
          multPriceRaw: price * this.boxQty,
          multPrice: this.humanPrice(price * this.boxQty),
          netSinglePriceRaw: netPrice,
          netSinglePrice: this.humanPrice(netPrice),
          netMultPriceRaw: netPrice * this.boxQty,
          netMultPrice: this.humanPrice(netPrice * this.boxQty),
        });
        netPrice = this.getPriceBoxRawForGroup(this.$store.getters.getUserGroupId, true);
        price = this.splittedTaxSingleRaw(netPrice);
        prices.push({
          key: 'lvl3Box',
          qty: this.boxQty,
          singlePriceRaw: price,
          singlePrice: this.humanPrice(price),
          multPriceRaw: price * this.boxQty,
          multPrice: this.humanPrice(price * this.boxQty),
          netSinglePriceRaw: netPrice,
          netSinglePrice: this.humanPrice(netPrice),
          netMultPriceRaw: netPrice * this.boxQty,
          netMultPrice: this.humanPrice(netPrice * this.boxQty),
        });
      }

      if (!this.noCalcTxt) {
        // Text Postcard
        if (this.$store.getters.getComposerModules.postcard.main.mode === 1 && this.$store.getters.getComposerModules.postcard.message.mode === 1 && this.$store.getters.getComposerModules.postcard.message.text.length > 320) {
          netPrice = this.$store.getters.getPricesExtraChars.default_net * 2;
          price = this.splittedTaxSingleRaw(netPrice);
          prices.push({
            key: 'postcard_text',
            qty: this.boxQty,
            singlePriceRaw: price,
            singlePrice: this.humanPrice(price),
            multPriceRaw: price * this.boxQty,
            multPrice: this.humanPrice(price * this.boxQty),
            netSinglePriceRaw: netPrice,
            netSinglePrice: this.humanPrice(netPrice),
            netMultPriceRaw: netPrice * this.boxQty,
            netMultPrice: this.humanPrice(netPrice * this.boxQty),
          });
        } else if (this.$store.getters.getComposerModules.postcard.main.mode === 1 && this.$store.getters.getComposerModules.postcard.message.mode === 1 && this.$store.getters.getComposerModules.postcard.message.text.length > 160) {
          netPrice = this.$store.getters.getPricesExtraChars.default_net;
          price = this.splittedTaxSingleRaw(netPrice);
          prices.push({
            key: 'postcard_text',
            qty: this.boxQty,
            singlePriceRaw: price,
            singlePrice: this.humanPrice(price),
            multPriceRaw: price * this.boxQty,
            multPrice: this.humanPrice(price * this.boxQty),
            netSinglePriceRaw: netPrice,
            netSinglePrice: this.humanPrice(netPrice),
            netMultPriceRaw: netPrice * this.boxQty,
            netMultPrice: this.humanPrice(netPrice * this.boxQty),
          });
        }
      }

      // Logo Postcard
      if (this.$store.getters.getComposerModules.postcard.main.mode === 1 && this.$store.getters.getComposerModules.postcard.addons.backLogo && this.boxQty >= this.$store.getters.getOrderQtySize.sm.min) {
        netPrice = this.$store.getters.getPricesLogoProduct.default_net;
        price = this.splittedTaxSingleRaw(netPrice);
        prices.push({
          key: 'postcard_logo',
          qty: this.boxQty,
          singlePriceRaw: price,
          singlePrice: this.humanPrice(price),
          multPriceRaw: price * this.boxQty,
          multPrice: this.humanPrice(price * this.boxQty),
          netSinglePriceRaw: netPrice,
          netSinglePrice: this.humanPrice(netPrice),
          netMultPriceRaw: netPrice * this.boxQty,
          netMultPrice: this.humanPrice(netPrice * this.boxQty),
        });
      }
      // Postcard
      if (this.$store.getters.getComposerModules.postcard.main.mode === 1) {
        if (!this.$store.getters.getPostcardExcludedGroups.includes(this.$store.getters.getUserGroupId.toString())) {
          netPrice = this.$store.getters.getPricesPostcard.default_net;
          price = this.splittedTaxSingleRaw(netPrice);
          prices.push({
            key: 'postcard_itself',
            qty: this.boxQty,
            singlePriceRaw: price,
            singlePrice: this.humanPrice(price),
            multPriceRaw: price * this.boxQty,
            multPrice: this.humanPrice(price * this.boxQty),
            netSinglePriceRaw: netPrice,
            netSinglePrice: this.humanPrice(netPrice),
            netMultPriceRaw: netPrice * this.boxQty,
            netMultPrice: this.humanPrice(netPrice * this.boxQty),
          });
        }
      }

      // Externe Grußkarte
      if (this.$store.getters.getComposerModules.postcard.main.mode === 2) {
        if (!this.$store.getters.getExternalCardExcludedGroups.includes(this.$store.getters.getUserGroupId.toString())) {
          netPrice = this.$store.getters.getPriceExternalCard.default_net;
          price = this.splittedTaxSingleRaw(netPrice);
          prices.push({
            key: 'postcard_external',
            qty: this.boxQty,
            singlePriceRaw: price,
            singlePrice: this.humanPrice(price),
            multPriceRaw: price * this.boxQty,
            multPrice: this.humanPrice(price * this.boxQty),
            netSinglePriceRaw: netPrice,
            netSinglePrice: this.humanPrice(netPrice),
            netMultPriceRaw: netPrice * this.boxQty,
            netMultPrice: this.humanPrice(netPrice * this.boxQty),
          });
        }
      }

      // Logo Schuber
      if (this.$store.getters.getComposerModules.postcard.addons.caseLogo && this.boxQty >= this.$store.getters.getOrderQtySize.md.min) {
        netPrice = this.$store.getters.getPricesSchuberProduct.default_net;
        price = this.splittedTaxSingleRaw(netPrice);
        prices.push({
          key: 'postcard_schuber',
          qty: this.boxQty,
          singlePriceRaw: price,
          singlePrice: this.humanPrice(price),
          multPriceRaw: price * this.boxQty,
          multPrice: this.humanPrice(price * this.boxQty),
          netSinglePriceRaw: netPrice,
          netSinglePrice: this.humanPrice(netPrice),
          netMultPriceRaw: netPrice * this.boxQty,
          netMultPrice: this.humanPrice(netPrice * this.boxQty),
        });
      }

      // Own motive
      if (this.$store.getters.getComposerModules.postcard.motive.mode === 2 && this.boxQty >= this.$store.getters.getOrderQtySize.md.min) {
        netPrice = this.$store.getters.getPricesOwnMotiveProduct.default_net;
        price = this.splittedTaxSingleRaw(netPrice);
        prices.push({
          key: 'postcard_ownmotive',
          qty: this.boxQty,
          singlePriceRaw: price,
          singlePrice: this.humanPrice(price),
          multPriceRaw: price * this.boxQty,
          multPrice: this.humanPrice(price * this.boxQty),
          netSinglePriceRaw: netPrice,
          netSinglePrice: this.humanPrice(netPrice),
          netMultPriceRaw: netPrice * this.boxQty,
          netMultPrice: this.humanPrice(netPrice * this.boxQty),
        });
      }

      if (this.$store.getters.getComposerModules.shipping.main.mode === 1 || this.$store.getters.getComposerModules.shipping.main.mode === 2) {
        // Qty=1
        if (this.$store.getters.getComposerModules.shipping.single.region === 'eu') {
          netPrice = 13.5;
          price = this.splittedTaxSingleRaw(netPrice);
          prices.push({
            key: 'shipping_eu',
            qty: this.boxQty,
            singlePriceRaw: price,
            singlePrice: this.humanPrice(price),
            multPriceRaw: price * this.boxQty,
            multPrice: this.humanPrice(price * this.boxQty),
            netSinglePriceRaw: netPrice,
            netSinglePrice: this.humanPrice(netPrice),
            netMultPriceRaw: netPrice * this.boxQty,
            netMultPrice: this.humanPrice(netPrice * this.boxQty),
          });
        } else if (this.$store.getters.getComposerModules.shipping.single.region === 'ch_uk') {
          netPrice = 35.0;
          price = this.splittedTaxSingleRaw(netPrice);
          prices.push({
            key: 'shipping_ch_uk',
            qty: this.boxQty,
            singlePriceRaw: price,
            singlePrice: this.humanPrice(price),
            multPriceRaw: price * this.boxQty,
            multPrice: this.humanPrice(price * this.boxQty),
            netSinglePriceRaw: netPrice,
            netSinglePrice: this.humanPrice(netPrice),
            netMultPriceRaw: netPrice * this.boxQty,
            netMultPrice: this.humanPrice(netPrice * this.boxQty),
          });
        } else if (this.$store.getters.getComposerModules.shipping.single.region === 'other') {
          netPrice = 45.0;
          price = this.splittedTaxSingleRaw(netPrice);
          prices.push({
            key: 'shipping_other',
            qty: this.boxQty,
            singlePriceRaw: price,
            singlePrice: this.humanPrice(price),
            multPriceRaw: price * this.boxQty,
            multPrice: this.humanPrice(price * this.boxQty),
            netSinglePriceRaw: netPrice,
            netSinglePrice: this.humanPrice(netPrice),
            netMultPriceRaw: netPrice * this.boxQty,
            netMultPrice: this.humanPrice(netPrice * this.boxQty),
          });
        } else {
          netPrice = 5.9;
          price = this.splittedTaxSingleRaw(netPrice);
          prices.push({
            key: 'shipping_de',
            qty: this.boxQty,
            singlePriceRaw: price,
            singlePrice: this.humanPrice(price),
            multPriceRaw: price * this.boxQty,
            multPrice: this.humanPrice(price * this.boxQty),
            netSinglePriceRaw: netPrice,
            netSinglePrice: this.humanPrice(netPrice),
            netMultPriceRaw: netPrice * this.boxQty,
            netMultPrice: this.humanPrice(netPrice * this.boxQty),
          });
        }
      } else if (this.$store.getters.getComposerModules.shipping.main.mode === 3) {
        // Qty > 1, single delivery
        if (this.$store.getters.getComposerModules.shipping.individual.international) {
          if (this.$store.getters.getComposerModules.shipping.individual.regions.de > 0) {
            netPrice = 5.9;
            price = this.splittedTaxSingleRaw(netPrice);
            prices.push({
              key: 'shipping_de',
              qty: this.$store.getters.getComposerModules.shipping.individual.regions.de,
              singlePriceRaw: price,
              singlePrice: this.humanPrice(price),
              multPriceRaw: price * this.$store.getters.getComposerModules.shipping.individual.regions.de,
              multPrice: this.humanPrice(price * this.$store.getters.getComposerModules.shipping.individual.regions.de),
              netSinglePriceRaw: netPrice,
              netSinglePrice: this.humanPrice(netPrice),
              netMultPriceRaw: netPrice * this.$store.getters.getComposerModules.shipping.individual.regions.de,
              netMultPrice: this.humanPrice(netPrice * this.$store.getters.getComposerModules.shipping.individual.regions.de),
            });
          }
          if (this.$store.getters.getComposerModules.shipping.individual.regions.eu > 0) {
            netPrice = 13.5;
            price = this.splittedTaxSingleRaw(netPrice);
            prices.push({
              key: 'shipping_eu',
              qty: this.$store.getters.getComposerModules.shipping.individual.regions.eu,
              singlePriceRaw: price,
              singlePrice: this.humanPrice(price),
              multPriceRaw: price * this.$store.getters.getComposerModules.shipping.individual.regions.eu,
              multPrice: this.humanPrice(price * this.$store.getters.getComposerModules.shipping.individual.regions.eu),
              netSinglePriceRaw: netPrice,
              netSinglePrice: this.humanPrice(netPrice),
              netMultPriceRaw: netPrice * this.$store.getters.getComposerModules.shipping.individual.regions.eu,
              netMultPrice: this.humanPrice(netPrice * this.$store.getters.getComposerModules.shipping.individual.regions.eu),
            });
          }
          if (this.$store.getters.getComposerModules.shipping.individual.regions.ch_uk > 0) {
            netPrice = 35.0;
            price = this.splittedTaxSingleRaw(netPrice);
            prices.push({
              key: 'shipping_ch_uk',
              qty: this.$store.getters.getComposerModules.shipping.individual.regions.ch_uk,
              singlePriceRaw: price,
              singlePrice: this.humanPrice(price),
              multPriceRaw: price * this.$store.getters.getComposerModules.shipping.individual.regions.ch_uk,
              multPrice: this.humanPrice(price * this.$store.getters.getComposerModules.shipping.individual.regions.ch_uk),
              netSinglePriceRaw: netPrice,
              netSinglePrice: this.humanPrice(netPrice),
              netMultPriceRaw: netPrice * this.$store.getters.getComposerModules.shipping.individual.regions.ch_uk,
              netMultPrice: this.humanPrice(netPrice * this.$store.getters.getComposerModules.shipping.individual.regions.ch_uk),
            });
          }
          if (this.$store.getters.getComposerModules.shipping.individual.regions.other > 0) {
            netPrice = 45.0;
            price = this.splittedTaxSingleRaw(netPrice);
            prices.push({
              key: 'shipping_other',
              qty: this.$store.getters.getComposerModules.shipping.individual.regions.other,
              singlePriceRaw: price,
              singlePrice: this.humanPrice(price),
              multPriceRaw: price * this.$store.getters.getComposerModules.shipping.individual.regions.other,
              multPrice: this.humanPrice(price * this.$store.getters.getComposerModules.shipping.individual.regions.other),
              netSinglePriceRaw: netPrice,
              netSinglePrice: this.humanPrice(netPrice),
              netMultPriceRaw: netPrice * this.$store.getters.getComposerModules.shipping.individual.regions.other,
              netMultPrice: this.humanPrice(netPrice * this.$store.getters.getComposerModules.shipping.individual.regions.other),
            });
          }
        } else {
          netPrice = 5.9;
          price = this.splittedTaxSingleRaw(netPrice);
          prices.push({
            key: 'shipping_de',
            qty: this.boxQty,
            singlePriceRaw: price,
            singlePrice: this.humanPrice(price),
            multPriceRaw: price * this.boxQty,
            multPrice: this.humanPrice(price * this.boxQty),
            netSinglePriceRaw: netPrice,
            netSinglePrice: this.humanPrice(netPrice),
            netMultPriceRaw: netPrice * this.boxQty,
            netMultPrice: this.humanPrice(netPrice * this.boxQty),
          });
        }
      } else if (this.$store.getters.getComposerModules.shipping.main.mode === 4) {
        // bulk, 1 or more locations, international or not
        if (
          (!this.$store.getters.getComposerModules.shipping.bulk.multipleLocations && !this.$store.getters.getComposerModules.shipping.bulk.international) ||
          (this.$store.getters.getComposerModules.shipping.bulk.multipleLocations && this.$store.getters.getComposerModules.shipping.bulk.regions.other === 0)
        ) {
          netPrice = 1.9;
          price = this.splittedTaxSingleRaw(netPrice);
          prices.push({
            key: 'shipping_bulk',
            qty: this.boxQty,
            singlePriceRaw: price,
            singlePrice: this.humanPrice(price),
            multPriceRaw: price * this.boxQty,
            multPrice: this.humanPrice(price * this.boxQty),
            netSinglePriceRaw: netPrice,
            netSinglePrice: this.humanPrice(netPrice),
            netMultPriceRaw: netPrice * this.boxQty,
            netMultPrice: this.humanPrice(netPrice * this.boxQty),
          });
        }

        if (this.$store.getters.getComposerModules.shipping.bulk.cardboardBoxWrap) {
          netPrice = this.$store.getters.getPricesSinglePackageProduct.default_net;
          price = this.splittedTaxSingleRaw(netPrice);
          prices.push({
            key: 'shipping_cardboardBoxWrap',
            qty: this.boxQty,
            singlePriceRaw: price,
            singlePrice: this.humanPrice(price),
            multPriceRaw: price * this.boxQty,
            multPrice: this.humanPrice(price * this.boxQty),
            netSinglePriceRaw: netPrice,
            netSinglePrice: this.humanPrice(netPrice),
            netMultPriceRaw: netPrice * this.boxQty,
            netMultPrice: this.humanPrice(netPrice * this.boxQty),
          });
        }
      } else if (this.$store.getters.getComposerModules.shipping.main.mode === 5) {
        // mixed
        if (this.$store.getters.getComposerModules.shipping.combined.international) {
          if (this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.de > 0) {
            netPrice = 5.9;
            price = this.splittedTaxSingleRaw(netPrice);
            prices.push({
              key: 'shipping_mixed_int_de',
              qty: this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.de,
              singlePriceRaw: price,
              singlePrice: this.humanPrice(price),
              multPriceRaw: price * this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.de,
              multPrice: this.humanPrice(price * this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.de),
              netSinglePriceRaw: netPrice,
              netSinglePrice: this.humanPrice(netPrice),
              netMultPriceRaw: netPrice * this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.de,
              netMultPrice: this.humanPrice(netPrice * this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.de),
            });
          }
          if (this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.eu > 0) {
            netPrice = 13.5;
            price = this.splittedTaxSingleRaw(netPrice);
            prices.push({
              key: 'shipping_mixed_int_eu',
              qty: this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.eu,
              singlePriceRaw: price,
              singlePrice: this.humanPrice(price),
              multPriceRaw: price * this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.eu,
              multPrice: this.humanPrice(price * this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.eu),
              netSinglePriceRaw: netPrice,
              netSinglePrice: this.humanPrice(netPrice),
              netMultPriceRaw: netPrice * this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.eu,
              netMultPrice: this.humanPrice(netPrice * this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.eu),
            });
          }
          if (this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.ch_uk > 0) {
            netPrice = 35.0;
            price = this.splittedTaxSingleRaw(netPrice);
            prices.push({
              key: 'shipping_mixed_int_ch_uk',
              qty: this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.ch_uk,
              singlePriceRaw: price,
              singlePrice: this.humanPrice(price),
              multPriceRaw: price * this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.ch_uk,
              multPrice: this.humanPrice(price * this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.ch_uk),
              netSinglePriceRaw: netPrice,
              netSinglePrice: this.humanPrice(netPrice),
              netMultPriceRaw: netPrice * this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.ch_uk,
              netMultPrice: this.humanPrice(netPrice * this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.ch_uk),
            });
          }
          if (this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.other > 0) {
            netPrice = 45.0;
            price = this.splittedTaxSingleRaw(netPrice);
            prices.push({
              key: 'shipping_mixed_int_other',
              qty: this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.other,
              singlePriceRaw: price,
              singlePrice: this.humanPrice(price),
              multPriceRaw: price * this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.other,
              multPrice: this.humanPrice(price * this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.other),
              netSinglePriceRaw: netPrice,
              netSinglePrice: this.humanPrice(netPrice),
              netMultPriceRaw: netPrice * this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.other,
              netMultPrice: this.humanPrice(netPrice * this.$store.getters.getComposerModules.shipping.combined.splitting.international.single.other),
            });
          }
          if (this.$store.getters.getComposerModules.shipping.combined.splitting.international.bulk.de > 0) {
            netPrice = 5.9;
            price = this.splittedTaxSingleRaw(netPrice);
            prices.push({
              key: 'shipping_mixed_int_bulk',
              qty: this.$store.getters.getComposerModules.shipping.combined.splitting.international.bulk.de,
              singlePriceRaw: price,
              singlePrice: this.humanPrice(price),
              multPriceRaw: price * this.$store.getters.getComposerModules.shipping.combined.splitting.international.bulk.de,
              multPrice: this.humanPrice(price * this.$store.getters.getComposerModules.shipping.combined.splitting.international.bulk.de),
              netSinglePriceRaw: netPrice,
              netSinglePrice: this.humanPrice(netPrice),
              netMultPriceRaw: netPrice * this.$store.getters.getComposerModules.shipping.combined.splitting.international.bulk.de,
              netMultPrice: this.humanPrice(netPrice * this.$store.getters.getComposerModules.shipping.combined.splitting.international.bulk.de),
            });
          }
        } else {
          if (this.$store.getters.getComposerModules.shipping.combined.splitting.national.single > 0) {
            netPrice = 5.9;
            price = this.splittedTaxSingleRaw(netPrice);
            prices.push({
              key: 'shipping_mixed_single',
              qty: this.$store.getters.getComposerModules.shipping.combined.splitting.national.single,
              singlePriceRaw: price,
              singlePrice: this.humanPrice(price),
              multPriceRaw: price * this.$store.getters.getComposerModules.shipping.combined.splitting.national.single,
              multPrice: this.humanPrice(price * this.$store.getters.getComposerModules.shipping.combined.splitting.national.single),
              netSinglePriceRaw: netPrice,
              netSinglePrice: this.humanPrice(netPrice),
              netMultPriceRaw: netPrice * this.$store.getters.getComposerModules.shipping.combined.splitting.national.single,
              netMultPrice: this.humanPrice(netPrice * this.$store.getters.getComposerModules.shipping.combined.splitting.national.single),
            });
          }
          if (this.$store.getters.getComposerModules.shipping.combined.splitting.national.bulk > 0) {
            netPrice = 1.9;
            price = this.splittedTaxSingleRaw(netPrice);
            prices.push({
              key: 'shipping_mixed_bulk',
              qty: this.$store.getters.getComposerModules.shipping.combined.splitting.national.bulk,
              singlePriceRaw: price,
              singlePrice: this.humanPrice(price),
              multPriceRaw: price * this.$store.getters.getComposerModules.shipping.combined.splitting.national.bulk,
              multPrice: this.humanPrice(price * this.$store.getters.getComposerModules.shipping.combined.splitting.national.bulk),
              netSinglePriceRaw: netPrice,
              netSinglePrice: this.humanPrice(netPrice),
              netMultPriceRaw: netPrice * this.$store.getters.getComposerModules.shipping.combined.splitting.national.bulk,
              netMultPrice: this.humanPrice(netPrice * this.$store.getters.getComposerModules.shipping.combined.splitting.national.bulk),
            });
          }
        }
      }

      return prices;
    },
    boxQty: {
      get() {
        return this.$store.getters.getSelectedQty;
      },
      set(value) {
        if (value === '' || value === '0') {
          value = this.$store.getters.getSelectedQty;
        }

        this.$root.$emit('changedQty', value);
        this.$store.commit('setSelectedQty', { qty: value, store: this.$store });

        if (parseInt(value) > 1) {
          this.switchCustomerType('b2b');
        }

        this.doReplace();

        if (this.$store.getters.isB2b) {
          this.$store.commit('setLevel1FilterB2bQty', value);
          //   this.$store.commit('setLevel2FilterB2bQty', value);
          this.$store.commit('setLevel3FilterB2bQty', value);
        }
      }
    }
  }
});
